import { APIProcessName, SQSProcessName } from "../process-names";

export const BANK_RECONCILIATION_SOURCE_TYPES = [
    APIProcessName.RECONCILE_TRANSACTIONS,
    SQSProcessName.CONTINUOUS_RECONCILIATION,
] as const;

export type BankReconciliationSourceType =
    (typeof BANK_RECONCILIATION_SOURCE_TYPES)[number];
